export const POWER_WORDS_REPORT = {
  name: "Power words",
  href: "/reports/teacher/power-words/",
  id: "power-words",
};

export const POWER_WORDS_STUDENT_REPORT = {
  name: "Power words",
  href: "/reports/teacher/power-words/student/",
  id: "student-power-words",
};

export const CLASSROOM_DATA_REPORT = {
  name: "Classroom data",
  href: "/reports/teacher/classroom-data/",
  id: "classroom-data",
};

export const STUDENT_DATA_REPORT = {
  name: "Student data",
  href: "/reports/teacher/student-data/",
  id: "student-data",
};

// The Main Idea reading skill content_id
export const MAIN_IDEA_READING_SKILL_CONTENT_ID = "ckmmfdxcj00033e5aq2r9soen";

export const AVAILABLE_CLASSROOM_READING_ACTIVITY_SORTING_KEYS = {
  views: "articles-viewed-count",
  textLevel: "article-lexile-level-viewed-average",
  activeTime: "article-time-average",
  quizzes: "quizzes-completed-count",
  quizScores: "quizzes-completed-score-average",
  writePromptScore: "write-prompts-score-average",
  annotations: "annotations-avg-count-by-article",
  powerWordsScore: "powerwords-quiz-score-average",
};

export const AVAILABLE_STUDENT_READING_ACTIVITY_SORTING_KEYS = {
  article: "article-content-id",
  viewedDate: "reading-session-date",
  textLevel: "article-lexile-level",
  time: "reading-session-time",
  quizScore: "quiz-score",
  quizCompletionDate: "quiz-completion-date",
  writePromptScore: "write-prompt-score",
  annotations: "annotations-submitted-count",
  powerWordsScore: "powerwords-quiz-score",
};
